export default "__VITE_ASSET__1ab84669__"